import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const REFERRAL_KEY = 'pactac_referral';

// Captures ?ref=CODE on any page; the last valid link clicked wins for its attribution window
export const ReferralTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const code = new URLSearchParams(location.search).get('ref');
    if (!code) return;
    axios
      .post(`${API}/affiliates/track-click`, { code, landing: location.pathname })
      .then(({ data }) => {
        if (!data.valid) return;
        const days = data.cookie_days || 30;
        localStorage.setItem(REFERRAL_KEY, JSON.stringify({ code: data.code, expires_at: Date.now() + days * 86400000 }));
      })
      .catch(() => {});
  }, [location.search, location.pathname]);

  return null;
};

export default ReferralTracker;
